import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'

import { makeUrlSalenoteVoid } from './connectionData.tsx'

const useSalenoteVoid = () => {
  const [errorSalenoteVoid, setErrorSalenoteVoid] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const salenoteVoid = async (_id: string, cause: string, by: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlSalenoteVoid()
      const res = await customPost<{ message: string }>(apiUrl, { _id, cause, by })
      setErrorSalenoteVoid(null)

      return res
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorSalenoteVoid(err)
      } else {
        setErrorSalenoteVoid(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorSalenoteVoid, loading, salenoteVoid }
}
export default useSalenoteVoid
